// extracted by mini-css-extract-plugin
module.exports = {"container":"TotalRow_container__oe10A","vertical":"TotalRow_vertical__xT1Gx","sum":"TotalRow_sum__OnUdR","amounts":"TotalRow_amounts__1uKf0"};